import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { Label } from '@src/design-system/label';
import { cn } from '@src/design-system/helpers';

import { EmailIcon } from '@shared/assets/icons/shared/email-icon';

import { Check } from 'lucide-react';
import type { ComponentProps } from 'react';
import type { TUser } from '@shared/types/user';
import { CloseSquare } from 'iconsax-react';

export const StudentAssigneeInfo = ({
  avatar,
  id,
  email,
  first_name,
  last_name,
  className,
  selected,
  onRemove,
}: TUser &
  Omit<ComponentProps<'div'>, 'id'> & {
    selected?: boolean;
    onRemove?: () => void;
  }) => {
  const INTERVIEWER_INFO = [
    {
      label: email,
      icon: <EmailIcon />,
    },
  ];
  const name = `${first_name} ${last_name}`;

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <Avatar className='size-10'>
        <AvatarImage src={avatar} />
        <AvatarFallback colorId={id}>{name.substring(0, 1)}</AvatarFallback>
      </Avatar>
      <div className='w-full flex-1'>
        <Label className='mb-1'>{name}</Label>
        <div className='flex items-center w-[90%] text-gray-600 text-sm'>
          {INTERVIEWER_INFO.map((info) => (
            <div
              key={info.label}
              className='flex items-center mr-4 overflow-hidden'
            >
              <div className='size-[16px] mr-1'>{info.icon}</div>
              <span
                title={info.label}
                className={cn('whitespace-nowrap', 'truncate')}
              >
                {info.label}
              </span>
              <span className='mx-2 last:hidden'>•</span>
            </div>
          ))}
        </div>
      </div>
      {typeof selected !== 'undefined' && (
        <div
          className={`rounded-sm border min-w-4 absolute right-3 ${selected ? 'bg-primary-1000' : 'h-4 w-4'} border-primary-800 `}
        >
          {selected && (
            <Check
              className=''
              color='white'
            />
          )}
        </div>
      )}
      {onRemove && (
        <CloseSquare
          size='20'
          onClick={onRemove}
          className='text-gray-800 me-3 cursor-pointer'
        />
      )}
    </div>
  );
};
